import { useEffect, useState } from 'react'
import { fetchShopByQuery } from '../../../../api'
import { Shop } from '../../../../types'
import useDebounce from '@/components/lib/useDebounce'

export const useShopSearch = (myarea_shops: Shop[]) => {
  const [shopId, setShopId] = useState<number | null>(null)
  const [shopName, setShopName] = useState('')
  const [chainName, setChainName] = useState('')
  const [chainLogoUrl, setChainLogoUrl] = useState<string | null>(null)
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState<Shop[]>([])
  const [isSearching, setIsSearching] = useState(false)
  const [isShopInputFocused, setIsShopInputFocused] = useState(false)

  const debouncedSearchQuery = useDebounce(searchQuery, 300)

  useEffect(() => {
    if (shopId !== null) {
      return
    }

    if (!debouncedSearchQuery) {
      setSearchResults(myarea_shops)
      return
    }

    setIsSearching(true)
    fetchShopByQuery(debouncedSearchQuery)
      .then((shops: Shop[]) => {
        setSearchResults(shops.concat(myarea_shops))
        setIsSearching(false)
      })
      .catch((_error) => {
        setIsSearching(false)
      })
  }, [debouncedSearchQuery, myarea_shops, shopId])

  const handleShopSearchChange = (value: string) => {
    setSearchQuery(value)
    // 入力が変更されたらshopIdをnullにリセット
    setShopId(null)
    setShopName('')
  }

  const handleShopInputFocus = () => {
    setIsShopInputFocused(true)
  }

  const handleShopInputBlur = () => {
    // すぐに非表示にすると、選択できなくなるため少し遅延させる
    setTimeout(() => {
      setIsShopInputFocused(false)
    }, 200)
  }

  const handleShopSelect = (shop: Shop) => {
    setShopId(shop.id)
    setShopName(shop.name)
    setChainName(shop.chain_name)
    setChainLogoUrl(shop.logo_url || null)
    setSearchQuery(`${shop.chain_name} ${shop.name}`)
    setSearchResults([])
  }

  return {
    shopId,
    shopName,
    chainName,
    chainLogoUrl,
    searchQuery,
    searchResults,
    isSearching,
    isShopInputFocused,
    handleShopSearchChange,
    handleShopInputFocus,
    handleShopInputBlur,
    handleShopSelect,
  }
}
